/**
 * DetailRelated component.
 */
import DetailContext from '@shared/components/utils/context/detailContext';
import DetailRelatedContainer from '@components/atoms/container/detailRelatedContainer';
import Focus from '@shared/types/enums/focus';
import RelatedRail from '@components/sections/rails/ui/rails/relatedRail';
import { setFocus } from '@shared/store/slices/focus.slice';
import { useAppDispatch } from '@shared/store/hooks';
import { useCallback, useContext, useEffect } from 'react';

/**
 * Displays the detail related section.
 */
export default function DetailRelated() {
  // ------------------------------------------------------------
  // Variables
  // ------------------------------------------------------------

  // Dispatch
  const dispatch = useAppDispatch();

  // Context
  const { focusable, related } = useContext(DetailContext);

  // ------------------------------------------------------------
  // Effect hooks
  // ------------------------------------------------------------

  useEffect(() => {
    if (related) {
      focusable.current.related = true;
    }
  }, [related]);

  // ------------------------------------------------------------
  // Actions
  // ------------------------------------------------------------

  /**
   * Handles the mouse enter event. Focuses the related section.
   */
  const onMouseEnter = useCallback(() => {
    dispatch(setFocus(Focus.RAILS_LIST));
  }, []);

  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------

  return related ? (
    <DetailRelatedContainer onMouseEnter={onMouseEnter}>
      <RelatedRail rail={related} />
    </DetailRelatedContainer>
  ) : null;
}
